module.exports = function() {
  return new Worker(__webpack_public_path__ + "77ba9026f49d1f37f551.worker.js");
};